import axios from "axios";
import { safeStorage } from "@/lib/safeStorage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = safeStorage.get("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default http;
